import React, { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import dayjs from 'dayjs'

// how to use:
// <Input key={item.id} {...register(item.field)} item={item} pieces={{ control, errors, toParent, size }} />

// schema example:
// { id: '__NEW_ID__', field: '__DB_FIELD__', type: 'input', inputType: 'number', label: 'ze label', required: 'wow u fucked', note: 'some other note', placeholder='Wow how r u' },

const Field = forwardRef(({ item, pieces, disabled, ...rest }, ref) => {
  if(!item.inputType) item.inputType = 'text';

  return (
    <Controller
      name={item.field}
      control={pieces.control}
      rules={{ required: item.required }}
      render={({ field }) => {
        if(!field.value) field.value = '';

        if(item.inputType==='date' && item.prefill!==false)
          field.value = field.value ? dayjs(field.value).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
        else if(item.inputType==='datetime-local' && item.prefill!==false)
          field.value = field.value ? dayjs(field.value).format('YYYY-MM-DDTHH:mm') : dayjs().format('YYYY-MM-DDTHH:mm');

        return (
          <div className={ pieces.size === 'sm' ? 'my-0' : 'my-2'}>
            {item.label && (<label htmlFor={item.field}>{item.label}</label>)}
            {item.note && (<p className="mb-1 text-muted fst-italic small">{item.note}</p>)}
            <input {...field}
              ref={field.ref}
              type={item.inputType}
              name={item.field}
              value={field.value}
              placeholder={item.placeholder}
              className={`form-control ${(pieces.size) ? "form-control-"+pieces.size : ""}`}
              onBlur={(e) => {
                if(pieces.toParent) pieces.toParent({ type: 'input', name: item.field, value: e.target.value });
              }}
              disabled={item.disabled} />
            {pieces.errors[item.field] && <p className="mt-0 error">{item.errorMsg}</p>}
          </div>
        )
      }}
    />
  )
});

export default Field;
